//Qualicorp

// HeaderDesktop
export const paddingHeaderDesktop = '10px 70px 10px 70px';
export const backgroundHeader = '#f9f9f9';
export const widthLogoDesktop = '140px';

// HeaderDesktop
export const backgroundHeaderMobile = '#f9f9f9';
export const widthLogoMobile = '140px';

// Form Button
export const colorBtnAddSubscriberBtnBackFormButton = '#171a88';
export const backgroundBtnFowardFormButton = '#171a88';
export const borderBtnBackFormButton = '#171a88';
export const backgroundBtnAddSubscriberFormButton = '#171a88'; // Adicionar Titular
export const colorBtnAddSubscriberkFormButton = 'white';
export const colorBtnAdvanceFormButton = 'white';
export const backgroundBtnAdvanceFormButton = '#171a88';
export const borderBtnAdvanceFormButton = '#171a88';
export const colorBorderBtn = '#171a88';
export const colorBorderBtnHover = '#171a64';
export const colorBackgroundChecked = '#171a88';

// Order Resume
export const colorTdOrderResume = '#171a88';
export const colorH2H4AnchorIconContainerOrderResume = '#171a88';
export const borderOrderResume = '#171a88';
export const backgroundApplyButtonOrderResume = '#171a88';

// StepCounter (progress bar)
export const textSpanTimeLine = '#171a88';

// Form Wrapper
export const borderTitularDepende = '#171a88';

// NavTabPayment
export const backgroundNavActivePayment = '#171a88';

// Subscriber Title
export const colorTitleSubscriber = '#171a88';

// Subscribers list Title
export const colorTitleListSubscribers = '#171a88';

// Subscribers list
export const colorListSubscribersFaRegEdit = '#171a88';

//Container
export const backgroundContainer = 'none';
